import util from '@/common/util';
import Data from '@/common/data';

const advRegisterPageKey = ['listing', 'listing-detail'];

// 如果有广告的注册配置就使用广告的注册方式
// test
window.mockDynamicRegister = function () {
    Data.creatorId = -9;

    util.setCookie('enableDynamicRegister', 1, 60);
};

/**
 * 组件已放在sign-log下，仅可使用isShow判断是否能显示广告注册弹窗
 */
export default {
    isShow() {
        return (
            // lp页面会在cookie存是否开启广告注册的开关状态enableDynamicRegister,所有的注册弹窗都换成广告注册
            (!Data.isLandingPage ||
                (Data.isLandingPage &&
                    Data.registration?.autopopup?.isDynamicRegister)) &&
            util.getCookie('enableDynamicRegister') == '1'
        );
    }
};
